<header>
  <app-header></app-header>
</header>

<mat-drawer-container>
  <mat-drawer #drawer mode="over" [opened]="drawerService.state()" (closedStart)="resetDrawerState()">
    <app-navbar/>
  </mat-drawer>
  <main class="main">
    <router-outlet/>
  </main>
</mat-drawer-container>
